// extracted by mini-css-extract-plugin
export default {"updatePassMain":"updatePassword_updatePassMain__cfyee","updatePasswordForm":"updatePassword_updatePasswordForm__QQT0K"};